export const ENVIRONMENT_PRODUCTION = 'PRODUCTION';
export const ENVIRONMENT_QA = 'QA';
export const ENVIRONMENT_DEVELOP = 'DEVELOP';

export const STATUSES = {
  ACTIVE: 'ACTIVO',
  INACTIVE: 'INACTIVO',
  BLOCKED: 'BLOQUEADO',
  PENDING: 'PENDIENTE',
  ALL: 'all'
};

export const STATUSES_NUM = {
  INACTIVE: 0,
  ACTIVE: 1,
  BLOCKED: 2,
  PENDING: 3,
  ELIMINADO: 4,
}


export const STATUS_OPTIONS = [
  { id: 1, name: 'Activo' },
  { id: 0, name: 'Inactivo' },
];